import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// マウント要素を探す（埋め込み先によって id が違う可能性があるため複数候補を試す）
const container = document.getElementById('bus-calendar') || document.getElementById('root');

// params を取得するヘルパー
const getInitialParams = () => {
	let params = {};

	// コンテナ要素の data-attributes をマージ
	if (container) {
		const dataParams = container.getAttribute('data-params');
		if (dataParams) {
			try {
				const parsed = JSON.parse(dataParams);
				params = { ...params, ...parsed };
			} catch (e) {
				console.warn('calendar: invalid JSON in data-params', e);
			}
		}
	}

	return params;
};

// レンダリング処理
let root = null;
const renderCalendar = () => {
	const params = getInitialParams();

	if (!container) {
		console.error('Calendar mount container not found (expected id "bus-calendar" or "root").');
		return;
	}

	if (Object.keys(params).length === 0) {
		if (root) {
			root.unmount();
			root = null;
		}
		return;
	}

	if (!root) {
		root = ReactDOM.createRoot(container);
	}

	root.render(
		<React.StrictMode>
			<App
				key={new Date()} 
				params={params}
			/>
		</React.StrictMode>
	);
};

// 初回レンダリング
renderCalendar();

// data-params の変更を監視
if (container) {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'attributes' && mutation.attributeName === 'data-params') {
				console.log('data-params changed, re-rendering...');
				renderCalendar();
			}
		});
	});

	observer.observe(container, {
		attributes: true,
		attributeFilter: ['data-params']
	});
}
